import type { FabricResource, ModelRoute } from "../../lib/schemas";
import { llmModels } from "./endpointConfiguration";
import { channelModelCapabilities } from "./channelModels";
import type { CanvasResource, DraftKind } from "./types";

export interface CreationDefaults {
  modelGrants: string[];
  toolGrants: string[];
  delegationGrants: string[];
  agentScopes: string[];
  profileId: string;
  profileVersion: number;
  virtualModelRoutes: ModelRoute[];
}

function firstModelRoute(resource: FabricResource): ModelRoute | null {
  const capabilities = channelModelCapabilities(resource);
  const capability = capabilities[0];
  if (!capability) return null;
  const preferred = llmModels(resource.configuration)[0];
  return {
    ordinal: 0,
    target_kind: "capability",
    target_id: capability.id,
    conversion_class: "lossless",
    route_config: preferred ? { upstream_model: preferred.upstream_name } : {}
  };
}

export function deriveCreationDefaults(kind: DraftKind, source?: CanvasResource): CreationDefaults {
  const defaults: CreationDefaults = {
    modelGrants: [],
    toolGrants: [],
    delegationGrants: [],
    agentScopes: [],
    profileId: "",
    profileVersion: 1,
    virtualModelRoutes: []
  };
  if (!source) return defaults;
  if (source.type === "resource") {
    const resource = source.value;
    if (resource.kind === "channel") {
      if (kind === "agent") {
        const preferred = llmModels(resource.configuration)[0];
        defaults.modelGrants = [
          preferred?.public_name.trim() ? preferred.public_name : resource.name
        ];
      } else if (kind === "model") {
        const route = firstModelRoute(resource);
        if (route) defaults.virtualModelRoutes = [route];
      }
    } else if (resource.kind === "mcp_server" && kind === "agent") {
      defaults.toolGrants = [resource.name];
    } else if (resource.kind === "a2a_endpoint" && kind === "agent") {
      defaults.delegationGrants = [resource.name];
    }
  }
  if (kind === "agent" && source.type === "virtual_model") {
    defaults.modelGrants = [source.value.public_name];
  }
  if (source.type === "agent") {
    if (kind === "key") defaults.agentScopes = [source.value.profile.id];
    if (kind === "task") {
      defaults.profileId = source.value.resource_id;
      defaults.profileVersion = source.value.version;
    }
  }
  return defaults;
}
